<template>
  <div
    class="side-nav-wrapper d-none d-sm-none d-lg-block"
    :class="{ collapsed: isActive }"
  >
    <div
      class="side-nav"
      :class="{ hide: isActive }"
    >
      <div class="side-nav-control">
        <button
          type="button"
          class="btn"
          @click="toggleActive"
        >
          <div class="d-flex align-items-center">
            <i class="apo-chevron-left-box text-xxlg me-1 text-neutral-70" />
            <i class="apo-chevron-right-box text-xxlg me-1 text-neutral-70" />
            <span class="text-sm fw700">Sembunyikan Menu</span>
            <div class="hover-menu">
              <div class="menu-title">
                Munculkan Menu
              </div>
            </div>
          </div>
        </button>
      </div>
      <div class="side-nav-menu">
        <ul class="list-unstyled">
          <li>
            <NuxtLink to="/dashboard-apo">
              <div class="d-flex align-items-center">
                <i class="apo-pie-cart text-xxlg me-1" />
                <span class="text-sm fw700">Dashboard APO</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Dashboard APO
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/monitoring-performance">
              <div class="d-flex align-items-center">
                <i class="apo-data-bar text-xxlg me-1" />
                <span class="text-sm fw700">Monitoring Performance</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Monitoring Performance
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
          <!-- Expandable menu -->
          <li
            @mouseenter="handleMouseEnter('hoverMenuMonitoringAnalytic')"
            @mouseleave="handleMouseLeave('hoverMenuMonitoringAnalytic')"
          >
            <div
              class="d-flex align-items-center expandable-menu"
              :class="{
                'router-link-active': isSubmenuMonitoringAnalyticsSelected,
              }"
              style="cursor: pointer"
              @click="openCloseSubmenuMonitoringAnalytics"
            >
              <i class="apo-dashboard-analytic text-xxlg me-1" />
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <span class="text-sm fw700 me-3">Monitoring Analytic</span>
                <i
                  v-if="!isActive"
                  class="apo-chevron-up text-xxlg chevron-transition fw600"
                  :class="{
                    'rotate-chevron': isSubmenuMonitoringAnalyticsOpen,
                  }"
                />
              </div>
              <div
                id="hoverMenuMonitoringAnalytic"
                class="hover-menu-monitoring-analytic"
                @mouseenter="handleMouseEnter('hoverMenuMonitoringAnalytic')"
                @mouseleave="handleMouseLeave('hoverMenuMonitoringAnalytic')"
              >
                <div class="menu-title">
                  Monitoring Analytic
                </div>
                <ul class="list-unstyled mt-2">
                  <li
                    v-for="(submenu, index) in monitoringAnalyticSubMenus"
                    :key="index"
                  >
                    <NuxtLink :to="submenu.to">
                      <div class="d-flex align-items-center">
                        <span class="text-sm fw700"> {{ submenu.label }} </span>
                      </div>
                    </NuxtLink>
                  </li>
                </ul>
              </div>
            </div>
            <ul
              v-if="isSubmenuMonitoringAnalyticsOpen"
              class="list-unstyled"
            >
              <li
                v-for="(submenu, index) in monitoringAnalyticSubMenus"
                :key="index"
              >
                <NuxtLink :to="submenu.to">
                  <div class="d-flex align-items-center ps-4">
                    <span class="text-sm fw700"> {{ submenu.label }} </span>
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </li>
          <li
            v-if="showMenu"
            @mouseenter="handleMouseEnter('hoverMenuTracking')"
            @mouseleave="handleMouseLeave('hoverMenuTracking')"
          >
            <div
              class="d-flex align-items-center expandable-menu"
              :class="{ 'router-link-active': isSubmenuTrackingSelected }"
              style="cursor: pointer"
              @click="openCloseSubmenuTracking"
            >
              <i class="apo-apo-tracking text-xxlg me-1" />
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <span class="text-sm fw700 me-3">Tracking</span>
                <i
                  v-if="!isActive"
                  class="apo-chevron-up text-xxlg chevron-transition fw600"
                  :class="{ 'rotate-chevron': isSubmenuTrackingOpen }"
                />
              </div>

              <div
                id="hoverMenuTracking"
                class="hover-menu-tracking"
                @mouseenter="handleMouseEnter('hoverMenuTracking')"
                @mouseleave="handleMouseLeave('hoverMenuTracking')"
              >
                <div class="menu-title">
                  Tracking
                </div>
                <ul class="list-unstyled mt-2">
                  <li
                    v-for="(submenu, index) in trackingMenus"
                    :key="index"
                  >
                    <NuxtLink :to="submenu.to">
                      <div class="d-flex align-items-center">
                        <span class="text-sm fw700"> {{ submenu.label }} </span>
                      </div>
                    </NuxtLink>
                  </li>
                </ul>
              </div>
            </div>
            <ul
              v-if="isSubmenuTrackingOpen"
              class="list-unstyled mt-2"
            >
              <li
                v-for="(submenu, index) in trackingMenus"
                :key="index"
              >
                <NuxtLink :to="submenu.to">
                  <div class="d-flex align-items-center ps-4">
                    <span class="text-sm fw700"> {{ submenu.label }} </span>
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </li>
          <!-- Role Management menu is temporarily disabled.
          <li v-if="!isMds">
            <NuxtLink to="/role-management">
              <div class="d-flex align-items-center">
                <i class="apo-apo-role-management text-xxlg me-1" />
                <span class="text-sm fw700">Manage Role</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Manage Role
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
          -->
          <li>
            <NuxtLink
              to="/claim-operational-sapa"
              :class="{ 'router-link-active': isClaimMenuActive }"
            >
              <div
                class="d-flex align-items-center"
              >
                <img
                  v-if="isClaimMenuActive"
                  :src="IcStarActive"
                  class="apo-data-bar text-xxlg ms-1 me-2"
                >
                <img
                  v-else
                  :src="IcStarInactive"
                  class="apo-data-bar text-xxlg ms-1 me-2"
                >
                <span class="text-sm fw700">Klaim Operasional SAPA</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Klaim Operasional SAPA
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/monitoring-refund">
              <div class="d-flex align-items-center">
                <i class="apo-attention-alt text-xxlg me-1" />
                <span class="text-sm fw700">Monitoring Refund</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Monitoring Refund
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink to="/monitoring-tag-i">
              <div class="d-flex align-items-center monitoring-tag-menu">
                <img
                  :src="MonitoringTagIcon"
                  class="monitoring-tag-icon ms-1 me-2"
                  alt=""
                >
                <span class="text-sm fw700">Monitoring Tag-I</span>
                <div class="hover-menu">
                  <div class="menu-title">
                    Monitoring Tag-I
                  </div>
                </div>
              </div>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useCrew } from '~/composables/stores/useCrewStore'
import { PositionCode } from '~~/constant/role.constant'

import IcStarActive from '~/assets/images/ic_star_active.svg?url'
import IcStarInactive from '~/assets/images/ic_star_inactive.svg?url'
import MonitoringTagIcon from '~/assets/images/ic_monitoring_tag.svg?url'

const { crewDataToken, tokenData } = useCrew()

const route = useRoute()
const isSubmenuMonitoringAnalyticsOpen = ref(false)
const isSubmenuTrackingOpen = ref(false)
const isActive = ref(false)
const activeSubmenu = ref<string | null>(null)

const showMenu = computed(() => {
    const today = new Date()
    const releaseDate = new Date('2025-12-22T04:00:00')
    return today >= releaseDate
})

function toggleActive () {
    isActive.value = !isActive.value
    isSubmenuMonitoringAnalyticsOpen.value = false
    isSubmenuTrackingOpen.value = false
}
const codePosition = PositionCode

const isAccess = ref<boolean>(false)

onMounted(() => {
    tokenData()

    const findPosition = codePosition.some(code =>
        crewDataToken.value?.psnc.includes(code),
    )

    if (findPosition === true) {
        isAccess.value = true
    }
})

const monitoringAnalyticSubMenus = [
    {
        label: 'GLI - New SAPA Performance',
        to: '/monitoring-analytic/gli-new-sapa-performance',
    },
    {
        label: 'Refund Alfagift Today',
        to: '/monitoring-analytic/refund-alfagift',
    },
    {
        label: 'Alfagift Late Reason Daily',
        to: '/monitoring-analytic/alfagift-late-reason',
    },
    {
        label: 'Alfagift APO ASO Store Daily',
        to: '/monitoring-analytic/alfagift-apo-aso',
    },
    {
        label: 'GLI - SAPA Pending Order H-4',
        to: '/monitoring-analytic/gli-sapa-pending-order',
    },
    {
        label: 'Alfagift Pengiriman Tunda Daily',
        to: '/monitoring-analytic/alfagift-pengiriman-tunda',
    },
    {
        label: 'Alfagift Lapor Equipment Daily',
        to: '/monitoring-analytic/alfagift-lapor-equipment',
    },
]

const isSubmenuMonitoringAnalyticsSelected = computed(() => {
    return monitoringAnalyticSubMenus.some(menu =>
        route.path.startsWith(menu.to),
    )
})

function openCloseSubmenuMonitoringAnalytics () {
    if (!isActive.value) {
        isSubmenuMonitoringAnalyticsOpen.value =
      !isSubmenuMonitoringAnalyticsOpen.value
    }
}

// Tracking Section Logic
const trackingMenus = [
    {
        label: 'Realtime Tracking',
        to: '/tracking/realtime-tracking',
    },
    {
        label: 'Tracking Report',
        to: '/tracking/tracking-report',
    },
    {
        label: 'Monitoring Position',
        to: '/tracking/monitoring-position',
    },
]

const isSubmenuTrackingSelected = computed(() => {
    return trackingMenus.some(menu => route.path.startsWith(menu.to))
})

const openCloseSubmenuTracking = () => {
    if (!isActive.value) {
        isSubmenuTrackingOpen.value = !isSubmenuTrackingOpen.value
    }
}

const mouseEnter = ref(false)
const mouseLeave = ref(false)
function handleMouseEnter (id: string) {
    const submenu = document.getElementById(id)
    if (isActive.value && submenu) {
        if (activeSubmenu.value && activeSubmenu.value !== id) {
            const previousSubmenu = document.getElementById(activeSubmenu.value)
            if (previousSubmenu) { previousSubmenu.style.display = 'none' }
        }
        mouseEnter.value = true
        mouseLeave.value = false
        submenu.style.display = 'block'
        activeSubmenu.value = id
    }
}

function handleMouseLeave (id: string) {
    const submenu = document.getElementById(id)
    if (isActive.value) {
        mouseEnter.value = false
        mouseLeave.value = true
        setTimeout(() => {
            if (!mouseEnter.value && mouseLeave.value && submenu) {
                submenu.style.display = 'none'
                if (activeSubmenu.value === id) {
                    activeSubmenu.value = null
                }
            }
        }, 500) // delay to prevent flicker
    }
}

const isClaimMenuActive = computed(() => {
    return route.path.startsWith('/claim-operational-sapa')
})

watchEffect(() => {
    isSubmenuMonitoringAnalyticsOpen.value =
    isSubmenuMonitoringAnalyticsSelected.value
})
watch(
    [ () => route.path, isActive ],
    ([ _currentPath, currentIsActive ]) => {
        isSubmenuMonitoringAnalyticsOpen.value =
      !currentIsActive && isSubmenuMonitoringAnalyticsSelected.value
        isSubmenuTrackingOpen.value =
      !currentIsActive && isSubmenuTrackingSelected.value

        if (currentIsActive && activeSubmenu.value) {
            const currentHoverSubmenu = document.getElementById(activeSubmenu.value)
            if (currentHoverSubmenu) {
                currentHoverSubmenu.style.display = 'none'
            }
            activeSubmenu.value = null
        }
    },
    { immediate: true },
)
</script>

<style lang="scss">
.side-nav-wrapper {
  position: fixed;
  top: 86px;
  background-color: $neutral-10;
  border-right: solid 1px $neutral-50;
  z-index: 999;
  height: 100%;
  ~ .content-wrapper {
    margin-left: 260px;
    transition:
      margin-left 0.5s,
      width 0.5s;
  }
  &.collapsed ~ .content-wrapper {
    margin-left: 85px;
    transition-duration: 0.5s;
  }
  .side-nav {
    width: 260px;
    transition-duration: 0.2s;
    &.hide {
      width: 83px;
      transition-duration: 0.5s;
      button {
        span {
          width: 0;
          overflow: hidden;
        }
      }
      a,
      .expandable-menu {
        span {
          width: 0;
          overflow: hidden;
        }
      }
      .side-nav-control {
        .btn {
          .apo-chevron-right-box {
            display: block;
          }
          .apo-chevron-left-box {
            display: none;
          }
          &:hover {
            .hover-menu {
              display: block;
            }
          }
        }
      }
      .side-nav-menu {
        ul {
          li {
            a,
            .expandable-menu {
              &:hover {
                .hover-menu {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
    .side-nav-control {
      padding: 12px 0;
      border-bottom: solid 1px $neutral-50;
      .btn {
        padding: 12px 24px;
        width: 100%;
        span {
          white-space: nowrap;
        }
        .apo-chevron-right-box {
          display: none;
        }
        .hover-menu {
          border: 1px solid $neutral-50;
          background-color: white;
          color: $dark;
          font-size: 12px;
          border-radius: 4px;
          padding: 10px;
          text-wrap: nowrap;
          position: absolute;
          left: 92px;
          display: none;
          &::before {
            content: "";
            position: absolute;
            background-color: white;
            width: 14px;
            height: 14px;
            left: -7px;
            top: 11px;
            background: linear-gradient(45deg, $neutral-50 50%, white 50%);
            transform: rotate(45deg);
            border-bottom-left-radius: 2px;
          }
          .menu-title {
            font-weight: 700;
            font-size: 12px;
          }
        }
        &:hover {
          background-color: $neutral-30;
          border-radius: 0;
        }
      }
    }
    .side-nav-menu {
      padding: 12px 0;
      ul {
        li {
          a,
          .expandable-menu {
            text-decoration: none;
            color: $dark;
            display: block;
            padding: 12px 24px;
            span {
              white-space: nowrap;
            }
            &.router-link-active {
              background-color: $primary;
              color: $neutral-10;
              .monitoring-tag-icon {
                filter: brightness(0) invert(1);
              }
              &:hover {
                background-color: $primary;
              }
            }
            .hover-menu-base {
              border: 1px solid $neutral-50;
              background-color: white;
              color: $dark;
              font-size: 12px;
              border-radius: 4px;
              text-wrap: nowrap;
              position: absolute;
              left: 92px;
              display: none;

              &::before {
                content: "";
                position: absolute;
                background-color: white !important;
                width: 14px;
                height: 14px;
                left: -7px;
                top: 11px;
                background: linear-gradient(45deg, $neutral-50 50%, white 50%);
                transform: rotate(45deg);
                border-bottom-left-radius: 2px;
              }
              .menu-title {
                font-weight: 700;
                font-size: 12px;
              }
            }
            .hover-menu {
              @extend .hover-menu-base;
              padding: 10px;
            }
            .hover-menu-monitoring-analytic {
              @extend .hover-menu-base;
              width: 220px;
              top: 210px;
              padding: 10px 0;
              .menu-title {
                margin-left: 1.5rem;
              }
              ul {
                border-top: 2px solid $neutral-50;
                li {
                  a {
                    span {
                      overflow: visible !important;
                    }
                  }
                }
              }
            }
            .hover-menu-tracking {
              @extend .hover-menu-base;
              width: 220px;
              top: 263px;
              padding: 10px 0;
              .menu-title {
                margin-left: 1.5rem;
                padding: 3px 0;
              }
              ul {
                border-top: 2px solid $neutral-50;
                li {
                  a {
                    span {
                      overflow: visible !important;
                    }
                  }
                }
              }
            }
            &:hover {
              background-color: $neutral-30;
            }
          }
          ul {
            li {
              a {
                &.router-link-active {
                  background: none;
                  color: $primary;
                  &:hover {
                    background: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.monitoring-tag-icon {
  display: block;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.apo-chevron-up:before {
  font-weight: 600;
}
.chevron-transition {
  display: inline-block;
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}

.rotate-chevron {
  transform: rotate(0deg);
}
</style>
